import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { pageview } from "@/lib/analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Send initial pageview for GA4 (SPA route changes should call pageview() on navigation)
try {
  pageview(window.location.pathname + window.location.search);
} catch (e) {
  // no-op if analytics not available
}
